import * as React from "react"
export const Svg_037 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={59}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M19.371 13.207c3.585 0 6.491-2.957 6.491-6.604 0-3.647-2.906-6.603-6.49-6.603-3.586 0-6.492 2.956-6.492 6.603s2.906 6.604 6.491 6.604Z"
    />
    <path
      fill="url(#b)"
      d="M44.64 14.112c1.373-3.37-.199-7.234-3.511-8.63-3.313-1.397-7.112.202-8.485 3.572-1.373 3.37.2 7.234 3.512 8.63 3.313 1.397 7.111-.202 8.484-3.572Z"
    />
    <path
      fill="url(#c)"
      d="M47.364 26.254H10.636v5.792l-4.315 6.027a13.242 13.242 0 0 0-2.481 7.755C3.84 53.09 9.648 59 16.788 59h24.424c7.14 0 12.948-5.909 12.948-13.172 0-2.806-.858-5.487-2.481-7.755l-4.315-6.027v-5.792Z"
    />
    <path
      fill="url(#d)"
      d="M50.762 22.797v9.073c2.59-.596 4.531-2.956 4.531-5.77v-7.913H2.707v7.914c0 2.813 1.94 5.173 4.531 5.77v-9.074h43.524Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={15.882}
        x2={22.203}
        y1={1.981}
        y2={12.037}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={33.107}
        x2={44.701}
        y1={13.092}
        y2={11.247}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={15.476}
        x2={27.516}
        y1={31.166}
        y2={61.109}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={14.867}
        x2={17.145}
        y1={20.24}
        y2={34.408}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)